import React from 'react'

export interface TabItem {
  id: string
  label: string
}

interface TabProps {
  items: TabItem[]
  activeTabId: string
  onTabChange: (tabId: string) => void
  className?: string
}

const Tab: React.FC<TabProps> = ({
  items,
  activeTabId,
  onTabChange,
  className = '',
}) => {
  return (
    <div
      className={`
        w-full
        flex
        items-center
        px-16px
        ${className}
      `}
    >
      {items.map((item) => {
        const isActive = activeTabId === item.id

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onTabChange(item.id)}
            className={`
              flex-1
              py-16px
              px-16px
              text-center
              border-b-2
              transition-all
              ${
                isActive
                  ? 'border-brandPrimary text-textColorText2'
                  : 'border-transparent text-textColorText2'
              }
            `}
          >
            <span
              className={`
              text-style-button1
              text-brown-80%-main
              transition-all
              ${isActive ? '' : 'opacity-50'}
            `}
            >
              {item.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default Tab
